import { Switch } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
/* Graphic Assets*/
import logo1080 from "../../images/Chamber-Media-Logo-p-1080.png";
import logo500 from "../../images/Chamber-Media-Logo-p-500.png";
import logo800 from "../../images/Chamber-Media-Logo-p-800.png";
import logo from "../../images/Chamber-Media-Logo.png";
/* Custom Hooks*/
import { useDarkMode } from "../hooks/useDarkMode";

export default function NavBar() {
	const [darkMode, setDarkMode] = useDarkMode(false);
	// const [isOpen, setIsOpen] = useState(false);

	const toggleDark = (e) => {
		e.preventDefault();
		setDarkMode(!darkMode);
	};

	// const handleOpen = (e) => {
	// 	e.preventDefault();
	// 	setIsOpen(!isOpen);
	// 	console.log(isOpen);
	// };

	// function responsiveNav() {
	// 	var x = document.getElementById("myTopnav");
	// 	if (x.className === "topnav") {
	// 		x.className += " responsive";
	// 	} else {
	// 		x.className = "topnav";
	// 	}
	// }

	// const closeAllMenusOnEsc = (e) => {
	// 	e = e || window.event;

	// 	if (e.key === "Escape" || e.keyCode === 27) {
	// 		this.setState({ areMenusOpen: false });
	// 	}
	// };
	function MenuLinks() {
		return (
			<div id="page-wrap">
				<nav
					role="navigation"
					id="mobileNavLinks"
					className="nav-menu-2 w-nav-menu "
				>
					<Link to="/" className="nav-link w-nav-link ">Home</Link>
					<Link to="/brain" className="nav-link w-nav-link ">
						The Brain
					</Link>
					{/* <Link to="/about" className="nav-link w-nav-link ">
						What Is The Brain?
					</Link>
					<Link to="/pricing" className="nav-link w-nav-link ">
						Pricing
					</Link>
					<Link to="/login" className="nav-link w-nav-link ">
						Log In
					</Link>
					<Link to="/signup" className="nav-link w-nav-link ">
						Sign Up
					</Link> */}
				</nav>
			</div>
		);
	}
	// let toggleNav = () => {
	// 	var x = document.getElementById("myLinks");
	// 	if (x.style.display === "block") {
	// 		x.style.display = "none";
	// 	} else {
	// 		x.style.display = "block";
	// 	}
	// };

	return (
		<div
			data-collapse="medium "
			data-animation="default "
			data-duration="400 "
			role="banner"
			className="navbar-3 w-nav "
		>
			{/* Darkmode switch */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "flex-end",
					margin: "0 2rem",
				}}
			>
				<h5 style={{ color: "white", alignSelf: "center", marginTop: "auto" }}>
					🌞
				</h5>
				<Switch checked={darkMode} onChange={toggleDark} name="darkModeSwitch" />
				<h5 style={{ color: "white", alignSelf: "center", marginTop: "auto" }}>
					🌙
				</h5>
			</div>

			<div className="container w-container ">
				<a href="/" className="brand w-nav-brand ">
					<img
						src={logo}
						loading="lazy "
						width="90 "
						sizes="90px "
						srcSet={`${logo500} 500w, ${logo800} 800w, ${logo1080} 1080w, ${logo} `}
						alt=" "
						className="chamber-logo "
					/>
					<h1 className="brain-nav-header ">The Brain</h1>
				</a>

				<MenuLinks />

				{/* <a href="" onClick={handleOpen}>
					<MenuIcon fontSize="large"  />
				</a> */}
				{/* <Menu
					right
					width={"20%"}
					isOpen={true}
					onClick={handleOpen}
					pageWrapId={"page-wrap"}
				>
					<MenuLinks />
				</Menu> */}
			</div>
		</div>
	);
}
